import { createAsyncThunk } from "@reduxjs/toolkit";
import Sessions from "utils/Sessions";
import { filterProjectStatusFunc, normalizeParamsAndAddValues } from "utils/methods/methods";
import ApiService from "../ApiService/ApiService";

const getToolBoxTalk = createAsyncThunk("tool-box-talk-list/api", async (params) => {
  const projectStatus = filterProjectStatusFunc();
  const projectStatusObj = { projectStatus };

  const updatedParams = normalizeParamsAndAddValues(params, projectStatusObj);

  const res = await ApiService.get(`toolbox-talk?${updatedParams}`, {
    headers: { Authorization: `Bearer ${Sessions.userToken}` },
  })
    .then((r) => r)
    .catch((error) => error.response);
  return res;
});

export const toolBoxTalkByIdThunk = createAsyncThunk("tool-box-talk-by-id/api", async (id) => {
  const res = await ApiService.get(`toolbox-talk/${id}`, {
    headers: { Authorization: `Bearer ${Sessions.userToken}` },
  })
    .then((r) => r)
    .catch((error) => error.response);
  return res;
});

export const deleteToolBoxTalkThunk = createAsyncThunk("delete-toolBox-talk/api", async (id) => {
  const res = await ApiService.delete(`toolbox-talk/${id}`, {
    headers: { Authorization: `Bearer ${Sessions.userToken}` },
  })
    .then((r) => r)
    .catch((err) => err.response);
  return res;
});

export const exportToolBoxTalkPdfStreamed = createAsyncThunk(
  "export-toolbox-talk-streamed/api",
  async (body) => {
    const res = await ApiService.post(`toolbox-talk/export-pdf`, body, {
      headers: {
        Authorization: `Bearer ${Sessions.userToken}`,
      },
    });

    return res.data;
  }
);

export const exportToolboxTalkZipThunk = createAsyncThunk(
  "export-toolbox-talk-zip/api",
  async (body) => {
    const res = await ApiService.post(`toolbox-talk/export-pdf-zip`, body, {
      headers: { Authorization: `Bearer ${Sessions.userToken}` },
      responseType: "blob",
    })
      .then((r) => r)
      .catch((err) => err.response);
    return { data: res.data, status: res.status, fileName: res.headers?.["content-disposition"] };
  }
);

export default getToolBoxTalk;
